{
  "_provenance": {
    "ns": "nav",
    "source": "src/i18n/keys/nav.ts (NAV_KEY, read by TRFerSidebar/Sidebar/BottomNav)"
  },
  "eyebrows": {
    "notFound": "Wayfinding · 404"
  },
  "groups": {
    "care": "Care",
    "community": "Community",
    "configure": "Configure",
    "grants": "Grants",
    "manage": "Manage",
    "network": "From TRF",
    "oversee": "Oversee",
    "system": "System",
    "trfApplications": "TRF Applications"
  },
  "items": {
    "accessControl": "Access control",
    "adminConversations": "Conversations",
    "adminDashboard": "Admin dashboard",
    "announcements": "Announcements",
    "applications": "Applications",
    "awards": "Awards",
    "calendar": "Calendar",
    "cardCharges": "Card charges (demo)",
    "committee": "Committee",
    "conversationReview": "Conversation review",
    "families": "Families",
    "forms": "Forms",
    "grantRequests": "Requests",
    "grants": "Grants",
    "handoffConfig": "Handoff config",
    "handoffOversight": "Handoff oversight",
    "health": "Health",
    "help": "Help",
    "importFamilies": "Import families",
    "partnerHospitals": "Partner hospitals",
    "paymentAccounts": "Payment accounts",
    "platformSettings": "Platform settings",
    "platformStats": "Platform stats",
    "polls": "Check-ins & polls",
    "publishPolicy": "Publish policy",
    "referralCodes": "Referral codes",
    "reimbursements": "Reimbursements (demo)",
    "resources": "Resources",
    "settings": "Settings",
    "support": "Resources",
    "systemHealth": "System health",
    "tasks": "Tasks",
    "today": "Today",
    "translationReports": "Translation reports",
    "unreads": "Unreads",
    "userFeedback": "User feedback",
    "users": "Users"
  },
  "tabs": {
    "chat": "Chat",
    "home": "Home",
    "more": "More"
  }
}
